import React from 'react';
import { CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
function FeatureItem({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex items-start gap-2 text-left" data-id="element-26">
      <div className="bg-[#eab308]/20 p-0.5 rounded-full flex-shrink-0 mt-0.5" data-id="element-27">
        <CheckIcon className="w-3 h-3 text-[#eab308]" strokeWidth={3} data-id="element-28" />
      </div>
      <span className="text-gray-300 text-xs sm:text-sm leading-snug" data-id="element-29">
        {children}
      </span>
    </div>;
}
export function ClosingSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section id="pricing" className="bg-black py-12 md:py-16 px-4 sm:px-6 border-t border-white/5" style={{
    scrollMarginTop: '80px'
  }} data-id="element-30">
      <div className="container mx-auto max-w-5xl" data-id="element-31">
        <div ref={ref1} className={`reveal text-center mb-8 ${vis1 ? 'is-visible' : ''}`} data-id="element-32">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4 leading-tight text-[#eab308]" data-id="element-33">
            Elegí tu formación
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-34">
            Dos opciones diseñadas para acompañarte en tu proceso de sanación y
            transformación.
          </p>
        </div>

        <div ref={ref2} className={`reveal grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-stretch mb-6 ${vis2 ? 'is-visible' : ''}`} data-id="element-35">
          {/* Premium Card — LEFT (recommended) */}
          <div id="premium" style={{
          scrollMarginTop: '80px'
        }} className="relative rounded-xl p-4 sm:p-6 flex flex-col bg-gradient-to-b from-[#111111] to-[#0a0a0a] border-2 border-[#eab308]/50 shadow-[0_0_50px_rgba(234,179,8,0.15)]" data-id="element-36">
            <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#eab308] to-[#d4a017] text-[#0f0f1a] text-[9px] font-bold px-3 py-0.5 rounded-full shadow-lg z-20 whitespace-nowrap" data-id="element-37">
              🔥 MÁS ELEGIDO
            </div>

            <div className="flex items-center gap-2 mb-4 mt-1" data-id="element-38">
              <span className="text-[#eab308] text-[10px] sm:text-xs font-bold tracking-[0.15em] uppercase" data-id="element-39">
                💎 PREMIUM
              </span>
            </div>

            <div className="text-center mb-5" data-id="element-40">
              <h3 className="text-xl sm:text-2xl font-serif font-bold text-white mb-3" data-id="element-41">
                BIODECODIFICACION Integral Premium
              </h3>
              <p className="text-3xl sm:text-4xl font-extrabold text-[#eab308] leading-none" data-id="element-42">
                $27.990
              </p>
              <p className="text-[#eab308] font-bold text-[10px] sm:text-xs mt-2" data-id="element-43">
                💳 Hasta 3 cuotas sin interés
              </p>
            </div>

            {/* Product Image */}
            <div className="w-full mb-4 rounded-lg overflow-hidden" data-id="element-44">
              <img src="https://cdn.magicpatterns.com/uploads/q6zSq1Pd5toxJ6Pd7uJKZe/hf_20260401_173131_ee962dd4-9818-4b5f-be8a-d9138eb81dd8.png" alt="BIODECODIFICACION Integral Premium - 6 Tomos + Vademécum" className="w-full h-auto max-h-48 sm:max-h-56 object-contain" data-id="element-45" />
            </div>

            <div className="space-y-2 mb-5 flex-grow" data-id="element-46">
              <FeatureItem data-id="element-47">6 Tomos completos de BIODECODIFICACION</FeatureItem>
              <FeatureItem data-id="element-48">6 Bonos exclusivos GRATIS</FeatureItem>
              <div className="bg-[#eab308]/10 border border-[#eab308]/20 rounded-lg p-3 mt-3" data-id="element-49">
                <p className="text-[#eab308] font-bold text-xs mb-1.5" data-id="element-50">
                  💎 Incluye además:
                </p>
                <FeatureItem data-id="element-51">
                  Vademécum Interactivo de BIODECODIFICACION
                </FeatureItem>
              </div>
              <div className="pt-2 border-t border-white/10 mt-2" data-id="element-52">
                <FeatureItem data-id="element-53">Acceso inmediato y de por vida</FeatureItem>
                <FeatureItem data-id="element-54">Garantía total sin preguntas</FeatureItem>
              </div>
            </div>

            <a href="https://pagos.academiaholisticaargentina.com/cart/48480180371673:1" target="_blank" rel="noopener noreferrer" className="w-full block py-3.5 md:py-4 rounded-xl text-[#0f0f1a] font-bold text-sm sm:text-base tracking-widest uppercase text-center transition-all duration-300 bg-[#eab308] hover:bg-[#d4a017] border border-[#eab308]/50 shadow-[0_0_30px_rgba(234,179,8,0.4)] hover:shadow-[0_0_40px_rgba(234,179,8,0.6)] hover:-translate-y-1 mt-auto" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-55">
              💎 QUIERO LA PREMIUM
            </a>
          </div>

          {/* Base Card — RIGHT */}
          <div className="relative rounded-xl p-4 sm:p-6 flex flex-col bg-[#111111] border-2 border-white/10" data-id="element-56">
            <div className="flex items-center gap-2 mb-4" data-id="element-57">
              <span className="text-gray-400 text-[10px] sm:text-xs font-bold tracking-[0.15em] uppercase" data-id="element-58">
                📦 INTEGRAL
              </span>
            </div>

            <div className="text-center mb-5" data-id="element-59">
              <h3 className="text-xl sm:text-2xl font-serif font-bold text-white mb-3" data-id="element-60">
                BIODECODIFICACION Integral
              </h3>
              <p className="text-3xl sm:text-4xl font-extrabold text-white leading-none" data-id="element-61">
                $19.990
              </p>
              <p className="text-gray-300 font-bold text-[10px] sm:text-xs mt-2" data-id="element-62">
                💳 Hasta 3 cuotas sin interés
              </p>
            </div>

            {/* Product Image */}
            <div className="w-full mb-4 rounded-lg overflow-hidden" data-id="element-63">
              <img src="https://cdn.magicpatterns.com/uploads/tK72KQLfG98CDWykEMoUXr/c6510cca-f955-45d1-a3f7-5dd0a234e9bb.png" alt="BIODECODIFICACION Integral - 6 Tomos" className="w-full h-auto max-h-48 sm:max-h-56 object-contain" data-id="element-64" />
            </div>

            <div className="space-y-2 mb-5 flex-grow" data-id="element-65">
              <FeatureItem data-id="element-66">6 Tomos completos de BIODECODIFICACION</FeatureItem>
              <FeatureItem data-id="element-67">6 Bonos exclusivos GRATIS</FeatureItem>
              <div className="pt-2 border-t border-white/10 mt-2" data-id="element-68">
                <FeatureItem data-id="element-69">Acceso inmediato y de por vida</FeatureItem>
                <FeatureItem data-id="element-70">Garantía total sin preguntas</FeatureItem>
              </div>
            </div>

            <a href="https://pagos.academiaholisticaargentina.com/cart/48480179650777:1" target="_blank" rel="noopener noreferrer" className="w-full block py-3.5 md:py-4 rounded-xl text-white font-bold text-sm sm:text-base tracking-widest uppercase text-center transition-all duration-300 bg-white/10 hover:bg-white/20 border border-white/20 hover:border-white/30 hover:-translate-y-1 mt-auto" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-71">
              📦 QUIERO LA INTEGRAL
            </a>
          </div>
        </div>

        <div className="max-w-md mx-auto text-center" data-id="element-72">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 mt-6 text-gray-400 text-xs sm:text-sm font-medium" data-id="element-73">
            <span className="flex items-center gap-1.5" data-id="element-74">
              <span className="text-base" data-id="element-75">⚡</span> Acceso inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-76">
              <span className="text-base" data-id="element-77">💻</span> 100% online
            </span>
            <span className="flex items-center gap-1.5" data-id="element-78">
              <span className="text-base" data-id="element-79">🔒</span> Pago seguro
            </span>
          </div>
        </div>

        <div className="mt-8 text-center text-gray-500 text-xs md:text-sm font-medium" data-id="element-80">
          <p className="italic" data-id="element-81">
            © Academia Holística Argentina — BIODECODIFICACION Integral
            <br data-id="element-82" />
            Material de uso educativo. No reemplaza diagnóstico ni tratamiento
            médico profesional.
          </p>
        </div>
      </div>
    </section>;
}